var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg83(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st9{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st14{font-family:'MongolianBaiti';}\r\n\t.st15{font-size:26.2005px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.23,
    cy: 23.82,
    r: 17.22
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 24.23,
    cy: 24.06,
    r: 13.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.78,7.67l2.33,1.89c0,0-13.67,13.67,0,28.56L8,40C8,40-6.67,24.56,7.78,7.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M40.32,7.89l-2.51,1.89c0,0,14.7,13.67,0,28.56l2.27,1.89C40.09,40.22,55.86,24.78,40.32,7.89z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(6.123234e-17 0.6673 -1 4.086092e-17 15.4395 19.5186)",
    className: "st14 st15"
  }, "8"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg83);
export default __webpack_public_path__ + "static/media/83.ccefae0017a9e655319dc48165b93358.svg";
export { ForwardRef as ReactComponent };